import { render, staticRenderFns } from "./MedicineAnalogsRecommendations.vue?vue&type=template&id=7aabbbb8&scoped=true"
import script from "./MedicineAnalogsRecommendations.vue?vue&type=script&lang=js"
export * from "./MedicineAnalogsRecommendations.vue?vue&type=script&lang=js"
import style0 from "./MedicineAnalogsRecommendations.vue?vue&type=style&index=0&id=7aabbbb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aabbbb8",
  null
  
)

export default component.exports